import { apiListWithInvitationCode } from '@/api/share'

const extractHost = (raw: string) => {
  const value = raw.trim()
  if (!value) return ''

  try {
    const url = new URL(/^https?:\/\//i.test(value) ? value : `https://${value}`)
    return url.hostname.toLowerCase()
  } catch {
    return value.split('/')[0].split(':')[0].toLowerCase()
  }
}

export async function saveShareCodeFromUrl() {
  const searchParams = new URLSearchParams(window.location.search)
  const rawShareCode = searchParams.getAll('shareCode')
  const localShareCode = (localStorage.getItem('shareCode') || '').trim()

  const shareCode = rawShareCode.find((code) => typeof code === 'string' && code.trim())?.trim()

  if (shareCode && !localShareCode) {
    localStorage.setItem('shareCode', shareCode)
    return
  }

  if (localShareCode) {
    return
  }

  try {
    const res = await apiListWithInvitationCode()
    if (res.code !== 200 || !Array.isArray(res.data)) return

    const currentHost = window.location.hostname.toLowerCase()
    const matched = res.data.find((item) => {
      if (!item?.exclusiveDomain) return false

      const hosts = item.exclusiveDomain.split(',').map(extractHost).filter(Boolean)
      return hosts.includes(currentHost)
    })

    if (matched?.invitationCode) {
      localStorage.setItem('shareCode', matched.invitationCode)
    }
  } catch (err: unknown) {
    //
  }
}
